import styled from 'styled-components';

import { styledLayout } from '@pkg/primitives';

export const InteriorWrapper = styled.div`
    ${styledLayout.fullWidthFix};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--yat_chip-gap);
    padding-left: var(--yat_chip-padding);
    padding-right: var(--yat_chip-padding);
    width: 100%;
    height: 100%;
`;
